module.exports = __webpack_public_path__ + "img/3.ea63718f.png";